/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import React              from 'react';
import PropTypes          from 'prop-types';
import { StyledLabel }    from '../../atoms/StyledLabel';
import { StyledTextarea } from '../../atoms/StyledTextarea';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const TextareaField = (props) => (
    <div>
        <StyledLabel htmlFor={props.id} hide={props.hideLabel}>{props.label}{props.required && '*'}</StyledLabel>
        <StyledTextarea {...props} />
    </div>
);

TextareaField.propTypes = {
    label: PropTypes.string,
    hideLabel: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/components/molecules/TextareaField/index.js